<ng-container *ngrxLet="activeLanguage$ as activeLanguage">
    <ng-container *ngIf="activeLanguage === 'pl'">
        <p>
            Wychodząc naprzeciw prośbom od Uczestników dotyczącym wydłużenia czasu trwania Etapu II (terminów na składanie Wniosków), PAŻP
            zmienił termin składania Wniosków z 30.06.2025 r. na <strong>11.08</strong>.2025 r.
        </p>
        <h4>KOMUNIKAT Z DNIA 27 CZERWCA 2025 R.</h4>
        <p>
            Mając na uwadze treść § 10 ust. 1 i 2 regulaminu Konkursu do naboru podmiotów do współpracy przy wdrożeniu usługi w ramach
            projektu "Rozbudowa i wyposażenie centrów kompetencji (specjalistyczne ośrodki szkoleniowe, ośrodki wsparcia wdrożeń, centra
            monitorowania) oraz infrastruktura do zarządzania ruchem pojazdów bezzałogowych jako ekosystem innowacji" (dalej:
            "<strong>Regulamin</strong>"), postanawia się co następuje:
        </p>
        <ol class="outer-list">
            <li>
                Regulamin ulega zmianie w ten sposób, że:
                <ol class="inner-list">
                    <li>
                        zmianie ulega § 6 ust. 2 Regulaminu, który otrzymuje następujące brzmienie:<br />
                        <em>"2. Konkurs prowadzony będzie w okresie od 19.03.2025 r. do <strong>27.08</strong>.2025 r."</em>
                    </li>
                    <li>
                        zmianie ulega § 6 ust. 5 Regulaminu, który otrzymuje następujące brzmienie: <br />
                        <em>
                            "5. Etap II Konkursu, w ramach którego nastąpi ocena Wniosków i wybór Uczestników do współpracy przy wdrożeniu
                            Usługi, przeprowadzony będzie od 01.04.2025 r. do <strong>27.08</strong>.2025 r. Termin składania Wniosków
                            ustala się od 01.04.2025 r. do <strong>11.08</strong>.2025 r. ("Etap II"). Ogłoszenie wyniku Etapu II nastąpi do
                            dnia <strong>27.08</strong>.2025 r. na stronie Krajowego Systemu Informacji Dronowej (<a
                                href="https://drony.gov.pl"
                                target="_blank"
                                rel="noopener norefer"
                            >
                                https://drony.gov.pl </a
                            >)."
                        </em>
                    </li>
                    <li>
                        zmianie ulega § 8 ust. 9 Regulaminu, który otrzymuje następujące brzmienie: <br />
                        <em>
                            "9. Dopuszcza się wysłanie filmu promocyjnego w innym terminie niż Wniosku, ale nie później niż do dnia
                            <strong>11.08</strong>.2025 r. W takim przypadku, wysyłając Wniosek należy poinformować, że film będzie
                            przesłany w innym terminie."
                        </em>
                    </li>
                    <li>
                        zmianie ulega § 8 ust. 11 Regulaminu, który otrzymuje następujące brzmienie: <br />
                        <em>
                            "11. Analiza i ocena wszystkich Wniosków złożonych w ramach Etapu II nastąpi najpóźniej do dnia
                            <strong>27.08</strong>.2025 r., przy czym okres ten może ulec przedłużeniu jeżeli będzie to uzasadnione i
                            niezbędne dla prawidłowej analizy i oceny Wniosków. Informacja o przedłużeniu terminu analizy i oceny Wniosków
                            zostanie przekazana Uczestnikom na adresy e-mail wskazane we Wnioskach."
                        </em>
                    </li>
                </ol>
            </li>
            <li>
                Ustala się tekst jednolity Regulaminu oraz zarządza jego niezwłoczną publikację pod adresem:
                <a href="https://drony.gov.pl" target="_blank" rel="noopener norefer"> https://drony.gov.pl </a>.
            </li>
            <li>
                Zmiany Regulaminu, o których mowa w pkt. 1 powyżej uzasadnione są licznymi wnioskami Uczestników o wydłużenie czasu trwania
                Etapu II. <br /><br />
                Jako główne powody wniosków Uczestnicy wskazywali potrzebę dokonania formalnych uzgodnień pomiędzy podmiotami wchodzącymi w
                skład konsorcjów, podjęcia stosownych uchwał czy uzyskania odpowiednich decyzji pozwalających Uczestnikom na udział w
                Konkursie lub Projekcie, którego Konkurs jest elementem. W wielu przypadkach ww. procesy są czynnościami czasochłonnymi,
                uzależnionymi od licznych lokalnych uwarunkowań i procedur wynikających z obowiązujących przepisów prawa.
                <br /><br />
                Mając powyższe na uwadze PAŻP przychylił się do wniosków i dokonał zmian jak w pkt. 1 powyżej.
            </li>
            <li>Zmiana Regulaminu wchodzi w życie z dniem 27 czerwca 2025 r.</li>
        </ol>
    </ng-container>
    <ng-container *ngIf="activeLanguage === 'en'">
        <p>
            Meeting the requests of Participants regarding the extension of Stage II (application submission deadlines), PANSA has changed
            the application submission deadline from 30.06.2025 to <strong>11.08</strong>.2025.
        </p>
        <h4>NOTICE OF 27 JUNE 2025</h4>
        <p>
            Taking into account the content of § 10 sections 1 and 2 of the Competition Rules for the recruitment of entities to cooperate
            in the implementation of the service under the project "Expansion and equipping of competence centers (specialized training
            centers, implementation support centers, monitoring centers) and infrastructure for unmanned vehicle traffic management as an
            innovation ecosystem" (hereinafter: the "<strong>Rules</strong>"), it is decided as follows:
        </p>
        <ol class="outer-list">
            <li>
                The Rules are amended as follows:
                <ol class="inner-list">
                    <li>
                        § 6 section 2 of the Rules is amended to read as follows:<br />
                        <em>"2. The competition will be held from 19.03.2025 to <strong>27.08</strong>.2025."</em>
                    </li>
                    <li>
                        § 6 section 5 of the Rules is amended to read as follows: <br />
                        <em>
                            "5. Stage II of the Competition, during which applications will be evaluated and Participants selected for
                            cooperation in the implementation of the Service, will be conducted from 01.04.2025 to
                            <strong>27.08</strong>.2025. The application submission period is from 01.04.2025 to <strong>11.08</strong>.2025
                            ("Stage II"). The result of Stage II will be announced by <strong>27.08</strong>.2025 on the website of the
                            National Drone Information System (<a href="https://drony.gov.pl" target="_blank" rel="noopener norefer">
                                https://drony.gov.pl </a
                            >)."
                        </em>
                    </li>
                    <li>
                        § 8 section 9 of the Rules is amended to read as follows: <br />
                        <em>
                            "9. It is allowed to send the promotional video at a different time than the application, but no later than
                            <strong>11.08</strong>.2025. In such a case, when submitting the application, it should be indicated that the
                            video will be sent at a different time."
                        </em>
                    </li>
                    <li>
                        § 8 section 11 of the Rules is amended to read as follows: <br />
                        <em>
                            "11. The analysis and evaluation of all applications submitted under Stage II will take place no later than
                            <strong>27.08</strong>.2025, although this period may be extended if justified and necessary for the proper
                            analysis and evaluation of applications. Information about the extension will be sent to Participants to the
                            e-mail addresses provided in the applications."
                        </em>
                    </li>
                </ol>
            </li>
            <li>
                The consolidated text of the Rules is established and its immediate publication at:
                <a href="https://drony.gov.pl" target="_blank" rel="noopener norefer"> https://drony.gov.pl </a> is ordered.
            </li>
            <li>
                The amendments to the Rules referred to in item 1 above are justified by numerous requests from Participants to extend the
                duration of Stage II. <br /><br />
                As the main reasons for the requests, Participants indicated the need to make formal arrangements between entities forming
                consortia, adopt appropriate resolutions, or obtain relevant decisions allowing Participants to take part in the Competition
                or Project of which the Competition is a part. In many cases, these processes are time-consuming, depending on numerous
                local conditions and procedures resulting from applicable legal regulations.
                <br /><br />
                Taking the above into account, PANSA has accepted the requests and made the changes as in item 1 above.
            </li>
            <li>The amendment to the Rules enters into force on 27 June 2025.</li>
        </ol>
        <p class="annotation">* Rules are only available in Polish language. Only translation of the announcement is provided here.</p>
    </ng-container>
</ng-container>
